export const LOOK_UP_FILTER = 'LOOK_UP_FILTER';
export const lookupFilter = (data) => ({
    type: LOOK_UP_FILTER,
    payload: data
});
